(function () {
  var page = document.querySelector('.cr-page');
  if (!page) return;
  document.documentElement.classList.add('cr-js');

  var cfgEl = document.getElementById('cr-config');
  var CFG = {};
  try { CFG = cfgEl ? JSON.parse(cfgEl.textContent) : {}; } catch (e) { CFG = {}; }
  var WA_NUM = '916354154054';
  var WA = 'https://wa.me/' + WA_NUM;
  var WA_TXT = '+91 63541 54054';
  var MAIL = 'support@ceryn.in';

  /* ---------- Reveal on scroll ---------- */
  var revealEls = page.querySelectorAll('.cr-reveal, .cr-stagger, .cr-meter');
  if ('IntersectionObserver' in window) {
    var ro = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); ro.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { ro.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- Copy coupon codes ---------- */
  page.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var code = b.getAttribute('data-copy');
    var label = b.querySelector('span');
    var done = function () {
      b.classList.add('done');
      if (label) { var old = label.textContent; label.textContent = 'Copied'; setTimeout(function () { label.textContent = old; b.classList.remove('done'); }, 1600); }
    };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done);
    else { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (x) {} t.remove(); done(); }
  });

  /* ---------- Size guide: inches / cm + size finder ---------- */
  var unitBtns = page.querySelectorAll('.cr-unit button');
  unitBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var cm = btn.getAttribute('data-unit') === 'cm';
      unitBtns.forEach(function (x) { x.classList.toggle('on', x === btn); });
      page.querySelectorAll('[data-in]').forEach(function (td) {
        var v = parseFloat(td.getAttribute('data-in'));
        td.textContent = cm ? String(Math.round(v * 2.54)) : td.getAttribute('data-in');
      });
      page.querySelectorAll('.cr-unit-label').forEach(function (s) { s.textContent = cm ? 'cm' : 'inches'; });
    });
  });
  var finder = page.querySelector('.cr-finder');
  if (finder) {
    finder.addEventListener('submit', function (e) {
      e.preventDefault();
      var bust = parseFloat(finder.bust.value), hip = parseFloat(finder.hip.value);
      var unit = finder.querySelector('select') ? finder.querySelector('select').value : 'in';
      var out = finder.querySelector('output');
      if (!bust && !hip) { out.innerHTML = 'Enter your bust and/or hip measurement.'; return; }
      if (unit === 'cm') { bust = bust / 2.54; hip = hip / 2.54; }
      var rows = [].map.call(page.querySelectorAll('.cr-size-table tbody tr'), function (tr) {
        return { tr: tr, size: tr.querySelector('th').textContent.trim(), bust: parseFloat(tr.children[1].getAttribute('data-in')), hip: parseFloat(tr.children[2].getAttribute('data-in')) };
      });
      var need = Math.max(bust || 0, (hip || 0) - 2);
      var pick = rows.filter(function (r) { return r.bust >= need - 0.25; })[0];
      page.querySelectorAll('.cr-size-table .hl').forEach(function (x) { x.classList.remove('hl'); });
      if (!pick) { out.innerHTML = 'Your measurements are above our largest size. Please <a href="' + WA + '" target="_blank" rel="noopener" style="color:#fff">message us on WhatsApp</a> and we will help.'; return; }
      [].forEach.call(pick.tr.children, function (c) { c.classList.add('hl'); });
      out.innerHTML = 'Suggested size: <b>' + pick.size + '</b> &nbsp;&middot;&nbsp; If you are between two sizes, choose the larger one. Always confirm with the chart on the product page.';
    });
  }

  /* ---------- Sticky offset below the theme header ---------- */
  function updateSticky() {
    var offset = 0;
    document.querySelectorAll('.shopify-section-group-header-group, sticky-header, .section-header, .header-wrapper').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > offset) offset = r.bottom;
      }
    });
    page.style.setProperty('--cr-sticky', Math.round(offset + 20) + 'px');
  }
  updateSticky();
  window.addEventListener('resize', updateSticky);

  /* ---------- Contents: mobile collapse, active section, progress ---------- */
  var toc = page.querySelector('.cr-toc');
  if (toc && window.matchMedia('(max-width: 860px)').matches) toc.removeAttribute('open');
  var article = page.querySelector('.cr-layout article');
  var bar = page.querySelector('.cr-progress i');
  function onScroll() {
    updateSticky();
    if (bar && article) {
      var r = article.getBoundingClientRect();
      var p = Math.min(1, Math.max(0, (window.innerHeight * 0.35 - r.top) / r.height));
      bar.style.width = (p * 100).toFixed(1) + '%';
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
  (function () {
    var links = page.querySelectorAll('.cr-toc a');
    var map = {};
    links.forEach(function (a) {
      map[a.getAttribute('href').slice(1)] = a;
      a.addEventListener('click', function () { if (toc && window.matchMedia('(max-width: 860px)').matches) toc.removeAttribute('open'); });
    });
    if (!('IntersectionObserver' in window) || !links.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          links.forEach(function (a) { a.classList.remove('active'); });
          var link = map[entry.target.id];
          if (link) link.classList.add('active');
        }
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    page.querySelectorAll('.cr-section').forEach(function (s) { io.observe(s); });
  })();

  /* ---------- Search ---------- */
  var root = document.getElementById('cr-search');
  if (!root) return;
  var input = document.getElementById('cr-search-input');
  var panel = document.getElementById('cr-search-results');

  var STOP = ('a an the is are am i im my me we our you your to of for in on at and or do does did can could ' +
    'will would how what when where why which if it its this that with be been get got have has please about ' +
    'there any much many need want should').split(' ');

  var BASE_SYN = [
    ['contact', 'whatsapp', 'phone', 'number', 'email', 'mail', 'support', 'call', 'help', 'customer care'],
    ['how long', 'timeline', 'business days', 'days', 'hours', 'delay', 'time'],
    ['fraud', 'scam', 'fake', 'abuse', 'cheat'],
    ['gstin', 'gst', 'invoice', 'legal name', 'seller', 'company', 'owner'],
    ['address', 'location', 'office', 'warehouse', 'store']
  ];
  var SYN = BASE_SYN.concat(CFG.syn || []);
  var KEYWORDS = CFG.keywords || {};
  var sellerId = CFG.sellerId || CFG.contactId || '';
  var contactId = CFG.contactId || '';

  // First match wins, so page-specific answers come before these general ones.
  var BASE_ANSWERS = [
    { match: ['gst', 'invoice', 'legal name', 'seller', 'company', 'owner'], q: 'Who is the seller?',
      a: 'Ceryn is a brand of <b>SURCOVE</b>, GSTIN <b>24AYNPV8697D1ZL</b>, 413, Crystal Corporation, Opp. Devi Darshan Soc, Rangani Farm Road, Near Royal Park Soc, Punagam, Surat 395010, Gujarat, India.', link: sellerId },
    { match: ['complaint', 'complain', 'escalate', 'grievance'], q: 'How do I raise a complaint?',
      a: 'Message us on WhatsApp <b>' + WA_TXT + '</b> or email <b>' + MAIL + '</b> with your order number and details of the issue. Our team will work with you to resolve it.', link: contactId },
    { match: ['contact', 'whatsapp', 'phone', 'number', 'email', 'mail', 'support', 'call', 'scam', 'fraud'], q: 'How do I contact Ceryn?',
      a: 'Only on WhatsApp <b>' + WA_TXT + '</b> (chat only) or email <b>' + MAIL + '</b>. Any other number, email or profile is not ours.', link: contactId }
  ];
  var ANSWERS = (CFG.answers || []).concat(BASE_ANSWERS).filter(function (x) { return x.link; });

  var index = [].map.call(page.querySelectorAll('.cr-section'), function (s) {
    var h = s.querySelector('h2'), n = h.querySelector('.n');
    var num = n ? n.textContent.trim() : '';
    var title = h.textContent.replace(num, '').trim();
    var all = (s.innerText || s.textContent).replace(/\s+/g, ' ').trim();
    var at = all.indexOf(title);
    var body = (at > -1 ? all.slice(at + title.length) : all).trim();
    return { el: s, id: s.id, num: num, title: title, tl: title.toLowerCase(), body: body, bl: body.toLowerCase(), kl: (KEYWORDS[s.id] || '').toLowerCase() };
  });

  var vocab = {};
  index.forEach(function (s) {
    (s.tl + ' ' + s.bl + ' ' + s.kl).split(/[^a-z0-9]+/).forEach(function (w) { if (w.length >= 4) vocab[w] = 1; });
  });
  SYN.forEach(function (g) { g.forEach(function (p) { p.split(' ').forEach(function (w) { if (w.length >= 4) vocab[w] = 1; }); }); });
  vocab = Object.keys(vocab);

  function lev(a, b) {
    if (Math.abs(a.length - b.length) > 2) return 9;
    var row = [], i, j;
    for (j = 0; j <= b.length; j++) row[j] = j;
    for (i = 1; i <= a.length; i++) {
      var prev = row[0]; row[0] = i;
      for (j = 1; j <= b.length; j++) {
        var tmp = row[j];
        row[j] = Math.min(row[j] + 1, row[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
        prev = tmp;
      }
    }
    return row[b.length];
  }

  function correct(word) {
    if (word.length < 4 || vocab.indexOf(word) > -1) return word;
    if (vocab.some(function (w) { return w.indexOf(word) === 0; })) return word;
    var best = word, limit = word.length > 6 ? 3 : 2;
    vocab.forEach(function (w) { var d = lev(word, w); if (d < limit) { limit = d; best = w; } });
    return best;
  }

  function analyse(q) {
    var words = q.toLowerCase().replace(/[^a-z0-9₹\s-]/g, ' ').replace(/\s+/g, ' ').trim().split(' ').filter(Boolean);
    var corrected = false;
    words = words.map(function (w) {
      if (STOP.indexOf(w) > -1) return w;
      var c = correct(w);
      if (c !== w) corrected = true;
      return c;
    });
    var tokens = words.filter(function (t) { return (t.length > 1 || /\d/.test(t)) && STOP.indexOf(t) < 0; });
    var phrase = ' ' + words.join(' ') + ' ';
    var syn = [];
    SYN.forEach(function (g) {
      var hit = g.some(function (p) {
        return phrase.indexOf(' ' + p + ' ') > -1 ||
          (p.indexOf(' ') < 0 && tokens.some(function (t) { return t.length >= 3 && p.indexOf(t) === 0; }));
      });
      if (hit) g.forEach(function (p) { if (syn.indexOf(p) < 0 && tokens.indexOf(p) < 0) syn.push(p); });
    });
    return { words: words, tokens: tokens, syn: syn, phrase: phrase, corrected: corrected, text: tokens.join(' ') };
  }

  function count(hay, needle) {
    var c = 0, i = hay.indexOf(needle);
    while (i > -1 && c < 5) { c++; i = hay.indexOf(needle, i + needle.length); }
    return c;
  }

  function score(s, a) {
    var sc = 0, matched = 0;
    a.tokens.forEach(function (t) {
      var hit = false, c;
      if (s.tl.indexOf(t) > -1) { sc += 12; hit = true; }
      if (s.kl.indexOf(t) > -1) { sc += 8; hit = true; }
      if ((c = count(s.bl, t))) { sc += 2 * c; hit = true; }
      if (hit) matched++;
    });
    a.syn.forEach(function (p) {
      if (s.tl.indexOf(p) > -1) sc += 5;
      if (s.kl.indexOf(p) > -1) sc += 3;
      sc += count(s.bl, p) * 0.5;
    });
    if (a.tokens.length > 1) sc += matched * 4;
    return sc;
  }

  function esc(s) {
    return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function termRegex(terms) {
    terms = terms.filter(function (t) { return t.length >= 3; })
      .sort(function (x, y) { return y.length - x.length; })
      .map(function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    return terms.length ? new RegExp('(' + terms.join('|') + ')', 'gi') : null;
  }

  function snippet(s, a) {
    var terms = a.tokens.concat(a.syn), pos = -1;
    for (var i = 0; i < terms.length && pos < 0; i++) pos = s.bl.indexOf(terms[i]);
    if (pos < 0) pos = 0;
    var start = Math.max(0, pos - 60), end = Math.min(s.body.length, pos + 130);
    if (start > 0) { var sp = s.body.indexOf(' ', start); if (sp > -1 && sp < pos) start = sp + 1; }
    var text = (start > 0 ? '… ' : '') + s.body.slice(start, end).trim() + (end < s.body.length ? ' …' : '');
    var re = termRegex(terms), html = esc(text);
    return re ? html.replace(re, '<mark class="cr-q">$1</mark>') : html;
  }

  function answerFor(phrase, tokens) {
    var i;
    for (i = 0; i < ANSWERS.length; i++) {
      if (ANSWERS[i].match.some(function (k) { return phrase.indexOf(' ' + k) > -1; })) return ANSWERS[i];
    }
    for (i = 0; i < ANSWERS.length; i++) {
      if (ANSWERS[i].match.some(function (k) {
        return tokens.some(function (t) { return t.length >= 3 && k.indexOf(t) === 0; });
      })) return ANSWERS[i];
    }
    return null;
  }

  var active = -1, lastTerms = [], lastSyn = [], timer;

  function options() { return panel.querySelectorAll('.cr-answer-link, .cr-result'); }
  function openPanel() { panel.classList.add('open'); input.setAttribute('aria-expanded', 'true'); }
  function closePanel() { panel.classList.remove('open'); input.setAttribute('aria-expanded', 'false'); active = -1; }

  function render() {
    var q = input.value.trim();
    root.classList.toggle('has-value', q.length > 0);
    if (q.length < 2) { closePanel(); panel.innerHTML = ''; return; }

    var a = analyse(q);
    lastTerms = a.tokens; lastSyn = a.syn;
    var results = index.map(function (s) { return { s: s, sc: score(s, a) }; })
      .filter(function (r) { return r.sc >= 2; })
      .sort(function (x, y) { return y.sc - x.sc; });
    if (results.length) {
      var cutoff = results[0].sc * 0.25;
      results = results.filter(function (r) { return r.sc >= cutoff; }).slice(0, 6);
    }
    var ans = answerFor(a.phrase, a.tokens);

    var html = '';
    if (a.corrected) html += '<div class="cr-results-note">Showing results for <b>' + esc(a.text) + '</b></div>';
    if (ans) {
      html += '<div class="cr-answer"><span class="cr-answer-tag">Quick answer</span>' +
        '<p class="cr-answer-q">' + ans.q + '</p><p class="cr-answer-a">' + ans.a + '</p>' +
        '<a class="cr-answer-link" role="option" href="#' + ans.link + '" data-id="' + ans.link + '">Read the full section &rarr;</a></div>';
    }
    if (results.length) {
      html += '<div class="cr-results-head">' + results.length + (results.length === 1 ? ' section matches' : ' sections match') + '</div>';
      results.forEach(function (r) {
        html += '<a class="cr-result" role="option" href="#' + r.s.id + '" data-id="' + r.s.id + '">' +
          '<span class="cr-result-title"><span class="n">' + r.s.num + '</span>' + esc(r.s.title) + '</span>' +
          '<span class="cr-result-snippet">' + snippet(r.s, a) + '</span></a>';
      });
    } else if (!ans) {
      html += '<div class="cr-empty"><p><b>No results for &ldquo;' + esc(q) + '&rdquo;</b></p><p>Try one of these:</p><div>' +
        (CFG.suggest || []).map(function (t) { return '<button type="button" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') +
        '</div></div>';
    }
    html += '<div class="cr-results-foot"><span>Still have a question?</span>' +
      '<a href="' + WA + '?text=' + encodeURIComponent('Hi Ceryn, I have a question about your ' + (CFG.name || 'policy') + ': ' + q) +
      '" target="_blank" rel="noopener">Ask us on WhatsApp</a></div>';

    panel.innerHTML = html;
    active = -1;
    openPanel();
  }

  function setActive(i) {
    var opts = options();
    if (!opts.length) return;
    active = (i + opts.length) % opts.length;
    opts.forEach(function (o, k) { o.classList.toggle('active', k === active); o.setAttribute('aria-selected', k === active); });
    opts[active].scrollIntoView({ block: 'nearest' });
  }

  function clearHits() {
    page.querySelectorAll('mark.cr-hit').forEach(function (m) {
      var p = m.parentNode;
      p.replaceChild(document.createTextNode(m.textContent), m);
      p.normalize();
    });
  }

  function highlight(section, terms) {
    var re = termRegex(terms);
    if (!re) return 0;
    var walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT, null), nodes = [], n;
    while ((n = walker.nextNode())) {
      if (n.parentNode.closest('h2 .n, script, style, svg')) continue;
      re.lastIndex = 0;
      if (re.test(n.nodeValue)) nodes.push(n);
    }
    var made = 0;
    nodes.forEach(function (node) {
      var frag = document.createDocumentFragment(), text = node.nodeValue, last = 0, m;
      re.lastIndex = 0;
      while ((m = re.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var mk = document.createElement('mark');
        mk.className = 'cr-hit';
        mk.textContent = m[0];
        frag.appendChild(mk);
        made++;
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
    return made;
  }

  function go(id) {
    var section = document.getElementById(id);
    if (!section) return;
    closePanel();
    clearHits();
    section.querySelectorAll('details').forEach(function (d) { if (lastTerms.some(function (t) { return d.textContent.toLowerCase().indexOf(t) > -1; })) d.open = true; });
    if (!highlight(section, lastTerms)) highlight(section, lastSyn);
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    section.classList.remove('cr-flash');
    void section.offsetWidth;
    section.classList.add('cr-flash');
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  }

  function runQuery(q) { input.value = q; input.focus(); render(); }

  input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(render, 90); });
  input.addEventListener('focus', function () { if (input.value.trim().length >= 2) render(); });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown') { e.preventDefault(); if (!panel.classList.contains('open')) render(); setActive(active + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
    else if (e.key === 'Enter') {
      var opts = options();
      if (opts.length) { e.preventDefault(); go(opts[active > -1 ? active : 0].getAttribute('data-id')); }
    } else if (e.key === 'Escape') {
      if (panel.classList.contains('open')) closePanel();
      else { input.value = ''; render(); clearHits(); }
    }
  });

  root.querySelector('.cr-search-clear').addEventListener('click', function () {
    input.value = ''; render(); clearHits(); input.focus();
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('.cr-search-btn')) {
      e.preventDefault();
      var opts = options();
      if (panel.classList.contains('open') && opts.length) go(opts[active > -1 ? active : 0].getAttribute('data-id'));
      else { input.focus(); render(); }
      return;
    }
    var chip = e.target.closest('[data-q]');
    if (chip) { e.preventDefault(); runQuery(chip.getAttribute('data-q')); return; }
    var link = e.target.closest('[data-id]');
    if (link) { e.preventDefault(); go(link.getAttribute('data-id')); }
  });

  document.addEventListener('click', function (e) { if (!root.contains(e.target)) closePanel(); });

  document.addEventListener('keydown', function (e) {
    var tag = (document.activeElement && document.activeElement.tagName) || '';
    if (e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test(tag) && !e.ctrlKey && !e.metaKey) {
      e.preventDefault();
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      input.focus({ preventScroll: true });
    }
  });

  var tocBtn = document.getElementById('cr-toc-search');
  if (tocBtn) tocBtn.addEventListener('click', function () {
    root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
  });
})();
